export interface UserPasswordInput {
  username: string;
  password: string;
}
